import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Maximize = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M14 4.00003H19C19.5523 4.00003 20 4.44775 20 5.00003V10M4 14V19C4 19.5523 4.44772 20 5 20H10M19.5 4.50003L14 10M10 14L4.5 19.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.25 4C13.25 3.58579 13.5858 3.25 14 3.25H19C19.9665 3.25 20.75 4.0335 20.75 5V10C20.75 10.4142 20.4142 10.75 20 10.75C19.5858 10.75 19.25 10.4142 19.25 10V5.81066L14.5303 10.5303C14.2374 10.8232 13.7626 10.8232 13.4697 10.5303C13.1768 10.2374 13.1768 9.76256 13.4697 9.46967L18.1893 4.75H14C13.5858 4.75 13.25 4.41421 13.25 4ZM3.25 14C3.25 13.5858 3.58579 13.25 4 13.25C4.41421 13.25 4.75 13.5858 4.75 14V18.1893L9.46967 13.4697C9.76256 13.1768 10.2374 13.1768 10.5303 13.4697C10.8232 13.7626 10.8232 14.2374 10.5303 14.5303L5.81066 19.25H10C10.4142 19.25 10.75 19.5858 10.75 20C10.75 20.4142 10.4142 20.75 10 20.75H5C4.0335 20.75 3.25 19.9665 3.25 19V14Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
